import repertoireReducer from "../repertoireReducer";
import kmsContentReducer from "../kmsContentReducer";
import kmsDocumentReducer from "../kmsDocumentReducer";
import kmsSearchReducer from "../kmsSearchReducer";
import kmsTaxonomyReducer from "../kmsTaxonomyReducer";

const kmsReducers = {
  repertoire: repertoireReducer,
  kmsContent: kmsContentReducer,
  kmsDocument: kmsDocumentReducer,
  kmsSearch: kmsSearchReducer,
  kmsTaxonomy: kmsTaxonomyReducer,
};

export default kmsReducers;
